// extracted by mini-css-extract-plugin
export var container = "_lo-0";
export var dotAnimation = "_lo-2";
export var dotsLoading = "_lo-1";